import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateShipmentFieldValue } from "../actions";
import { selectCountryList010, selectCountryList199 } from "../selectors";

export const useSelectDestCntryByDeclaration=(isImportShipment,destinationCountry,saveData)=>{
   
    const countryList=useSelector(selectCountryList199)
    const declaration=useSelector(state=>state.Shipment?.exitInfo?.declaration)
    const CountryList010=useSelector(selectCountryList010)
    const dispatch=useDispatch()

    useEffect(()=>{
        if(!declaration && countryList.length>0){
             const currentDeclaration=countryList.find(c=>c.value==destinationCountry)?.type
            saveData({exitInfo:{declaration:currentDeclaration}})
            dispatch(updateShipmentFieldValue({declaration:currentDeclaration}))
        }
    },[destinationCountry,countryList])

    return React.useMemo(()=>{
        if(isImportShipment) return CountryList010 
        else if(!declaration) return []
         else  return countryList.filter(c=>c.type==declaration)
    },[isImportShipment,CountryList010,countryList,declaration])

}